import { BaseServiceProvider } from './BaseServiceProvider'
import { Vehicle } from 'src/store/models/Vehicles'
import {
  IByPartPayLoad,
  ImageBypartAPIResponse,
} from 'src/api/searchResults/interfaces'

class PartExtServiceProvider extends BaseServiceProvider {
  // Cache for the byParts endpoint. The endpoint will not return any data for invalid/not found parts.
  // We are caching the empty parts also to avoid unnecessary requests.
  private byPartsCache = new Map<string, ImageBypartAPIResponse | undefined>()

  constructor() {
    super(import.meta.env.VITE_API_BASE_URL, 'partext', '1.1', '')
  }

  getPartAttributesByPart = async (
    byPartPayLoad: IByPartPayLoad[],
    vehicle?: Vehicle
  ): Promise<Array<ImageBypartAPIResponse>> => {
    // If there are no parts, skip the request.
    if (!byPartPayLoad.length) {
      return []
    }

    // Collect cache miss parts.
    const missedParts: IByPartPayLoad[] = byPartPayLoad.filter(
      (part) => !this.byPartsCache.has(`${part.lineCode}_${part.partNumber}`)
    )

    try {
      // Skip the api call if all parts are hit.
      if (missedParts.length > 0) {
        // Fetch missing parts.
        const resp = await this.post<Array<ImageBypartAPIResponse>>(
          `part/attributes/byParts`,
          missedParts,
          {
            params: {
              catalogId: vehicle?.type ? vehicle.type.id : 111,
            },
          }
        )

        if (resp.status === 200) {
          // Push all the missed parts into the cache.
          missedParts.forEach((part) =>
            this.byPartsCache.set(
              `${part.lineCode}_${part.partNumber}`,
              (resp.data || []).find(
                (respPart) =>
                  respPart.linecode === part.lineCode &&
                  respPart.partNumber === part.partNumber
              )
            )
          )
        }
      }
      // Fetch and return all the requested parts from the cache.
      return (
        byPartPayLoad
          .map((part) =>
            this.byPartsCache.get(`${part.lineCode}_${part.partNumber}`)
          )
          // Cleanup empty parts.
          .filter((part) => part)
      )
    } catch (_error) {
      // eslint-disable-next-line no-console -- Bulk disabling. Fix if possible.
      console.log('error fetching image')
    }

    return []
  }
}

export default new PartExtServiceProvider()
